
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const base = namespace("base");
const staff = namespace("staff");
const serviceItem = namespace("service-item");
const inventory = namespace("inventory");
const customer = namespace("customer");
const user = namespace("user");
const parts = namespace("parts");
const service = namespace("service");
const app = namespace("app");

@Component({})
export default class MissPoint extends Vue {
  @Prop({ type: Object, default: () => {} })
  orderData: any;
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @user.State userData;
  @staff.Action getTechnicianStaffList;
  @serviceItem.Action getServiceItemList;
  @serviceItem.Action getServiceDetail;
  @inventory.Action queryPartsInventoryOnBatch;
  @customer.Action getCustomerDetail;
  @parts.Action getPartsInventoryList;
  @service.Action getOrderDetail;
  @app.State btnLoading;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  advisorList: any[] = [{}];
  technicianStaffList: any[] = [];
  serviceItemList: any[] = [];
  defaultVehicleList: any[] = [];
  partsList: any[] = [];
  showAdditional: boolean = false;
  orderFormData: any = {
    orderDateType: "1", // 1到店 2到店预约
    reservationArrivalTime: "",
    orderAmount: "0",
    additionalFees: "",
    additionalFeesRemark: "",
    advisorCode: "",
    customerCode: "",
    customerCurrentMileage: "",
    customerMobile: "",
    customerModelCode: "",
    customerName: "",
    customerNextMaintenanceDate: "",
    customerNextMileage: "",
    customerOilVolume: 0,
    leaveTime: dayjs().format("YYYYMMDD"),
    plateCode: "",
    partsDetail: [],
    serviceDetail: [],
    paymentList: [],
    discountList: []
  };
  definitionServiceData: any = {
    serviceCode: "",
    workingHours: "",
    amount: "",
    technicianCode: [],
    saleCode: "",
    remark: "",
    manual: true,
    partsList: []
  };
  definitionPartsData: any = {
    partsCode: "",
    partsName: "",
    quantity: "",
    sellingPrice: "",
    technicianCode: [],
    saleCode: "",
    amount: "",
    remark: "",
    manual: true
  };
  // 控制form disable状态
  formDisableStatus = {
    plateCode: false,
    customerModelCode: false,
    customerName: false,
    customerMobile: false
  };
  //计算属性
  get getPayments() {
    return this.orderFormData.paymentList
      .map(item => {
        return item.paidMethodDesc;
      })
      .join(",");
  }
  get getDiscountAmount() {
    return (
      this.orderFormData.discountList &&
      this.orderFormData.discountList.reduce((total, currentValue) => {
        return total + Number(currentValue.discountAmount);
      }, 0)
    );
  }
  get getOrderAmount() {
    this.orderFormData.orderTotalAmount = (
      this.getServiceAmount +
      Number(this.orderFormData.additionalFees) +
      this.getPartsAmount
    ).i18nToFixed();
    return (this.getServiceAmount + Number(this.orderFormData.additionalFees) + this.getPartsAmount).i18nToFixed();
  }
  get getServiceAmount() {
    return this.orderFormData.serviceDetail.reduce((total, currentValue) => {
      return total + Number(currentValue.amount);
    }, 0);
  }
  get getPartsAmount() {
    return this.orderFormData.partsDetail.reduce((total, currentValue) => {
      if (!currentValue.isGroupParts) {
        return total + Number(currentValue.amount);
      } else {
        return total;
      }
    }, 0);
  }
  get getActualAmount() {
    this.orderFormData.receiptAmount = this.getOrderAmount - this.getDiscountAmount;
    return this.getOrderAmount - this.getDiscountAmount;
  }
  get breadData() {
    return [];
  }
  get orderId() {
    return this.$route.params.id;
  }
  created() {
    this.init();
  }

  init() {
    // 选择打印
    this.initMissPoint();
  }
  get additionalData() {
    return [
      {
        additionalFees: this.orderFormData.additionalFees,
        additionalFeesRemark: this.orderFormData.additionalFeesRemark
      }
    ];
  }
  deleteAdditional() {
    this.showAdditional = false;
    this.orderFormData.additionalFees = "";
    this.orderFormData.additionalFeesRemark = "";
  }
  deleteItem(key, index) {
    if (key === "serviceDetail" && this.orderFormData.serviceDetail[index].groupServiceIndex) {
      let service = this.orderFormData.serviceDetail[index];
      for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
        let parts = this.orderFormData.partsDetail[partsIndex];
        if (parts.groupServiceIndex === service.groupServiceIndex) {
          this.orderFormData.partsDetail.splice(partsIndex, 1);
          partsIndex--;
        }
      }
    }
    this.orderFormData[key].splice(index, 1);
  }
  addAdditionCost() {
    // 控制表格显示
    this.showAdditional = true;
  }
  handleSearchServiceItemList(name = "") {
    this.getServiceItemList({
      pageSize: 20,
      pageNum: 1,
      searchKey: name,
      serviceClass: ""
      // serviceClass: this.orderType === "maintenance" ? "1" : "2"
    }).then(data => {
      this.serviceItemList = this.$safeValue(data, "data.list", []);
    });
  }
  roderMapping: any = {
    "1": "maintenance",
    "2": "wash",
    "3": "retail"
  };
  groupIndex: number = 1;
  get orderType() {
    return this.$route.query.type || this.roderMapping[this.orderFormData.orderType];
  }
  isAdd() {
    return false;
  }
  handleChooseParts(val, index) {
    // this.getPartsDetail({
    //   partsCode: val
    // }).then(data => {
    //   const partsData = data.data;
    //   this.orderFormData.partsDetail.splice(index, 1, partsData);
    //   this.computedAmount(2, index);
    // });
    let partsData = Object.assign(
      {},
      this.definitionPartsData,
      this.partsList.find(item => item.partsCode === val)
    );
    this.orderFormData.partsDetail.splice(index, 1, partsData);
    this.computedAmount(2, index);
  }
  handleAddService() {
    this.orderFormData.serviceDetail.push(Object.assign({}, this.definitionServiceData));
  }
  handleAddParts() {
    this.orderFormData.partsDetail.push(Object.assign({}, this.definitionPartsData));
  }
  handleChooseServiceItem(val, index) {
    this.getServiceDetail({
      serviceCode: val
    }).then(data => {
      const serviceData = data.data || {};
      Object.assign(serviceData, {
        amount: serviceData.serviceFee,
        partsList: [],
        technicianCode: [],
        saleCode: this.userData.userCode
      });
      this.orderFormData.serviceDetail.splice(index, 1, serviceData);
      if (serviceData.serviceType === "2" && serviceData.servicePartsList.length > 0) {
        let _index = (serviceData.groupServiceIndex = this.groupIndex);
        const partsCodeArr = serviceData.servicePartsList.map(parts => parts.partsCode);
        const partsRequireNum = serviceData.servicePartsList.map(parts => parts.servicePartsQty);
        this.queryPartsInventoryOnBatch({
          partsCodeArray: partsCodeArr
        }).then(data => {
          const partsArr = data.data;
          partsArr.forEach((item, parstIndex) => {
            let partsData = Object.assign({}, this.definitionPartsData, {
              isGroupParts: true,
              saleCode: "",
              partsName: item.partsName,
              partsUnit: item.partsUnit,
              sellingPrice: item.sellingPrice, // 套餐内零配件不算钱
              invQty: item.invQty,
              quantity: partsRequireNum[parstIndex],
              partsCode: item.partsCode,
              serviceCode: val,
              groupServiceIndex: _index
            });
            this.orderFormData.partsDetail.push(partsData);
            this.orderFormData.serviceDetail[index].partsList.push(partsData);
          });
        });
        this.groupIndex++;
      }
      // 添加到服务项列表回显并去重
      if (
        !this.serviceItemList.some(serviceItem => {
          return serviceItem.serviceCode === serviceData.serviceCode;
        })
      ) {
        this.serviceItemList.push({
          serviceCode: serviceData.serviceCode,
          serviceName: serviceData.serviceName
        });
      }
      this.clearParts();
      this.computedAmount(1, index);
    });
  }
  computedAmount(type, index) {
    console.log(type, index);
    // type: 1-服务，2-零配件，3-附加费
    if (type === 1) {
      //
    } else if (type === 2) {
      if (this.orderFormData.partsDetail[index].isGroupParts) {
        // 套餐零配件不算钱
        this.orderFormData.partsDetail[index].amount = 0;
        return;
      }
      let amount =
        (this.orderFormData.partsDetail[index].quantity || 0) * this.orderFormData.partsDetail[index].sellingPrice;
      this.orderFormData.partsDetail[index].amount = amount.i18nToFixed();
    } else if (type === 3) {
      //
    }
    this.computedTotalAmount();
  }
  computedTotalAmount() {
    const serviceTotal = this.orderFormData.serviceDetail.reduce((preV, curV) => preV + Number(curV.amount), 0);
    const partsTotal = this.orderFormData.partsDetail.reduce((preV, curV) => preV + Number(curV.amount), 0);
    if (Object.is(NaN, serviceTotal) || Object.is(NaN, partsTotal)) {
      return this.$message.error(t("setting.enter-quantity-or-amount"));
    }
    console.log(serviceTotal, partsTotal);
    this.orderFormData.orderAmount = (
      serviceTotal +
      partsTotal +
      Number(this.orderFormData.additionalFees)
    ).i18nToFixed();
  }
  clearParts() {
    // 清除未匹配的套餐零配件
    const selectedServiceGroupIndexArr = this.orderFormData.serviceDetail.map(item => {
      return item.groupServiceIndex;
    });
    for (let partsIndex = 0; partsIndex < this.orderFormData.partsDetail.length; partsIndex++) {
      let currentParts = this.orderFormData.partsDetail[partsIndex];
      // 是套餐中的零配件，并且下标在项目中不存在
      if (currentParts.serviceCode && !selectedServiceGroupIndexArr.includes(currentParts.groupServiceIndex)) {
        this.orderFormData.partsDetail.splice(partsIndex, 1);
        partsIndex--;
      }
    }
  }
  getPartsLists(name = "") {
    this.getPartsInventoryList({
      pageNum: 1,
      pageSize: 20,
      searchKey: name
    }).then(data => {
      this.partsList = (data.data?.list || []).map(item => {
        item.partsNameDesc = item.partsCustomizeCode
          ? `${item.partsNameDesc}(${item.partsCustomizeCode})`
          : item.partsNameDesc;
        return item;
      });
    });
  }
  async initMissPoint() {
    this.getStaffList({
      // 获取所有员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
      this.orderFormData.advisorCode = this.userData.userCode;
      this.definitionServiceData.saleCode = this.userData.userCode;
      this.definitionPartsData.saleCode = this.userData.userCode;
    });
    this.getTechnicianStaffList({
      // 获取角色为技师的员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      console.log("[ data ]", data);
      this.technicianStaffList = data.data.list;
    });
    await this.handleSearchServiceItemList();
    await this.getPartsLists();
    this.getOrderDetail({
      orderNo: this.orderData.orderNo || this.orderId
    }).then(data => {
      const serviceCodeMap = {}; // 存放映射关系
      data.data.partsDetail.forEach((parts, index) => {
        parts.isFlag = true;
        if (parts.technicianArray) {
          // 格式化技师code
          parts.technicianCode = parts.technicianArray.map(item => {
            console.log("[  item.technicianCode]", item.technicianName, item.technicianCode);
            return {
              userCode: item.technicianCode,
              staffName: item.technicianName
            };
          });
        }
        if (parts.serviceCode) {
          if (serviceCodeMap[parts.serviceCode]) {
            serviceCodeMap[parts.serviceCode].push(index);
          } else {
            serviceCodeMap[parts.serviceCode] = [index];
          }
        }
      });
      data.data.serviceDetail.forEach(serviceItem => {
        serviceItem.isFlag = true;
        if (serviceItem.technicianArray) {
          // 格式化技师code
          serviceItem.technicianCode = serviceItem.technicianArray.map(item => {
            return {
              userCode: item.technicianCode,
              staffName: item.technicianName
            };
          });
        }
        if (serviceCodeMap[serviceItem.serviceCode]) {
          serviceItem.isGroup = true;
          serviceItem.groupServiceIndex = this.groupIndex;
          serviceCodeMap[serviceItem.serviceCode].forEach(i => {
            data.data.partsDetail[i].isGroupParts = true;
            data.data.partsDetail[i].groupServiceIndex = this.groupIndex;
          });
          this.groupIndex++;
        }
      });
      data.data.serviceDetail.forEach(item => {
        // 回显并去重
        if (
          !this.serviceItemList.some(serviceItem => {
            return serviceItem.serviceCode === item.serviceCode;
          })
        ) {
          this.serviceItemList.push({
            serviceCode: item.serviceCode,
            serviceName: item.serviceName
          });
        }
      });
      this.orderFormData = data.data;
      if (!this.orderFormData.paymentList.length) {
        this.orderFormData.paymentList = [
          {
            paidAmount: 0,
            paidMethod: "3",
            paidMethodDesc: t("service.wechat-pay")
          }
        ];
      }
      data.data.partsDetail.forEach(item => {
        if (
          !this.partsList.some(partsItem => {
            return partsItem.partsCode === item.partsCode;
          })
        ) {
          this.partsList.push({
            partsCode: item.partsCode,
            partsName: item.partsName
          });
        }
      });
      this.orderFormData.leaveTime =
        this.orderFormData.leaveTime && dayjs(this.orderFormData.leaveTime).format("YYYYMMDD");
      this.orderFormData.customerNextMaintenanceDate =
        this.orderFormData.customerNextMaintenanceDate &&
        dayjs(this.orderFormData.customerNextMaintenanceDate).format("YYYYMMDD");
      if (data.data.additionalFees) {
        this.showAdditional = true;
      }
      this.defaultVehicleList = [
        {
          lastValue: data.data.customerModelCode,
          name: data.data.modelDesc
        }
      ];
      this.formDisableStatus.plateCode = true;
      this.formDisableStatus.customerModelCode = true;
      this.formDisableStatus.customerName = !!data.data.customerName;
      this.formDisableStatus.customerMobile = !!data.data.customerMobile;
    });
  }
  vehicleDataFormat(data) {
    const tempArr = [];
    data.forEach(item => {
      if (item.brandCode && item.seriesName && item.modelCode) {
        tempArr.push({
          lastValue: item.modelCode,
          name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
          valueGroup: [item.brandCode, item.seriesName, item.modelCode]
        });
      }
    });
    return tempArr;
  }
  setCustomerData(vehicleCode, customerCode) {
    this.getCustomerDetail({
      customerCode: customerCode,
      vehicleCode: vehicleCode
    }).then(data => {
      const customerData = data.data;
      const vehicleData = data.data.vehicleList.find(item => {
        return data.data.selectedVehicleCode === item.vehicleCode;
      });
      this.orderFormData.customerCode = customerCode;
      this.orderFormData.customerName = customerData.customerName;
      this.orderFormData.customerMobile = customerData.mobile;
      this.orderFormData.vehicleCode = vehicleCode;
      this.formDisableStatus.customerModelCode = !!this.defaultVehicleList.length;
      this.formDisableStatus.customerName = !!customerData.customerName;
      this.formDisableStatus.customerMobile = !!customerData.mobile;
      if (vehicleData) {
        this.orderFormData.plateCode = vehicleData.plateCode || "";
        this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
        this.orderFormData.customerNextMileage = vehicleData.nextMaintenanceMileage || "";
        this.orderFormData.customerNextMaintenanceDate = vehicleData.nextMaintenanceDate || "";
        this.formDisableStatus.plateCode = !!vehicleData.plateCode;
      }
      // 获取到车辆信息重新验证格式
      if (this.defaultVehicleList.length) {
        this.$nextTick(() => {
          (this.$refs["customerForm"] as any).validateField("customerModelCode");
        });
      }
      if (this.orderFormData.plateCode) {
        this.$nextTick(() => {
          (this.$refs["customerForm"] as any).validateField("plateCode");
        });
      }
    });
  }
  searchParts(val) {
    this.getPartsLists(val);
  }
  //   ////
}
